<template>
	<v-toolbar flat :color="headerColor" height="30px" style="z-index: 103; position: relative;">
		<v-toolbar-items v-if="isEditable">
			<v-btn flat color="white" class="pa-0 ma-0 btn-toggle-board-left-position" @click="onToggleBoardLeftPosition">
				<v-icon v-if="isBoardLeftPosition">last_page</v-icon>
				<v-icon v-else>first_page</v-icon>
			</v-btn>
			<v-btn flat large color="white" class="pa-0 ma-0" @click="viewmode">編集終了</v-btn>
			<v-btn flat :color="undoColor" class="pa-0 ma-0 caption" @click="undo" :class="undoClass">
				<v-icon>undo</v-icon>
			</v-btn>
			<v-btn flat :color="redoColor" class="pa-0 ma-0 caption" @click="redo" :class="redoClass">
				<v-icon>redo</v-icon>
			</v-btn>
		</v-toolbar-items>
		<v-toolbar-items v-else>
			<v-btn flat color="white" class="pa-0 ma-0 btn-toggle-board-left-position" @click="onToggleBoardLeftPosition">
				<v-icon v-if="isBoardLeftPosition">last_page</v-icon>
				<v-icon v-else>first_page</v-icon>
			</v-btn>
			<v-btn flat large color="white" class="pa-0 ma-0" @click="editmode"
				v-if="canEdit">
					編集
			</v-btn>
			<v-btn flat large color="grey" class="pa-0 ma-0 disabled"
				v-else>
					編集
			</v-btn>
			<v-btn flat large color="white" class="pa-0 ma-0" @click="onShowPrintSchedule">印刷</v-btn>
			<v-btn flat large color="white" class="pa-0 ma-0" v-if="use_photo" @click="onShowPhotoMng">写真</v-btn>
		</v-toolbar-items>
		<v-spacer></v-spacer>
		<v-toolbar-items>
			<v-menu
				ref="beginCalendar"
				v-model="beginCalendar"
				:close-on-content-click="false"
				:nudge-right="40"
				lazy
				transition="scale-transition"
				full-width
			>
				<template v-slot:activator="{ on }">
					<v-btn flat large class="white--text btn-move-date" v-on="on">
						指定日に移動
					</v-btn>
				</template>
				<v-date-picker
					v-model="begin_date"
					no-title
					@input="onSelectBeginDate"
					locale="jp-ja"
					:day-format="date => new Date(date).getDate()"
				></v-date-picker>
			</v-menu>
			<v-btn flat large color="white" @click="scrollToday">今日</v-btn>
			<v-layout hidden-sm-and-down>
				<v-divider class="ml-2 mr-4" inset vertical color="white"></v-divider>
				<v-btn-toggle v-model="toggleTick" mandatory class="transparent pr-2" style="height: 30px;">
					<v-btn v-for="term in terms" :key="term.id" :value="term.id"
						flat
						large
						class="white--text"
					>
						{{term.text}}
					</v-btn>
				</v-btn-toggle>
			</v-layout>
			<Menu @show-edit-member-self="$emit('show-edit-member-self')" 
				v-bind:toggleTick="toggleTick"
				v-bind:terms="terms"
				v-on:change-calendar-tick="onChangeCalendarTick"
				v-on:show-edit-project-pinned="onClickShowEditProjectPinned"
			/>
		</v-toolbar-items>
		<template v-slot:extension v-if="show_extension">
			<GBHeaderSimpleDisplaySwitch />
		</template>
		<v-toolbar-items class="btn-toggle-extension">
			<v-btn flat small color="white" class="mb-0" @click="onToggleExtension">
				<v-icon v-if="show_extension" style="height: 15px;">arrow_drop_up</v-icon>
				<v-icon v-else style="height: 15px;">arrow_drop_down</v-icon>
			</v-btn>
		</v-toolbar-items>
	</v-toolbar>
</template>

<script>
import Menu from './Menu';
import GBHeaderSimpleDisplaySwitch from './GBHeaderSimpleDisplaySwitch';
import { CALENDAR_TICK } from '../data/Const';
import DataSetManager from '../classes/DataSetManager';
import Notification from '../classes/Notification';
import Util from '../classes/Util';

export default {
	name: 'GBHeader',
	components: {
		Menu,
		GBHeaderSimpleDisplaySwitch,
	},
	props: [ 'isEditable', 'use_photo' ],
	data(){
		return {
			terms: [
				{ id: CALENDAR_TICK.TERM, text: '半'},
				{ id: CALENDAR_TICK.DAY , text: '日'},
				{ id: CALENDAR_TICK.WEEK, text: '週'}
			],
			toggleTick: this.$store.getters.calendarTick,
			dataset_manager: this.$store.getters.datasetManager,
			show_extension: true,
			beginCalendar: false,
			begin_date: null,
		}
	},
	methods: {
		onChangeCalendarTick:function(e){
			if(this.toggleTick != e.value){
				this.toggleTick = e.value;
			}
		},
		onToggleBoardLeftPosition: function() {
			this.$store.dispatch('toggleBoardLeftPosition');
		},
		onToggleExtension: function() {
			this.show_extension = !this.show_extension;
			this.$emit('header-extension', this.show_extension);
		},
		onShowPrintSchedule: function(e) {
			this.$emit("show-print-schedule", e);
		},
		onShowPhotoMng: function() {
			this.$store.dispatch('setSaveDisplayLeftDay', this.$store.getters.displayLeftDay);
			let uri = '';
			if (this.$store.getters.isDisplayListTypeMember){
				uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'member'].join('/');
			} else {
				uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project'].join('/');
			}
			this.$router.push(uri);
		},
		editmode: function () {
			this.$emit('fetch-data', {
				callback: () => {
					this.$store.dispatch('setModeEdit');
				},
			});
		},
		viewmode: function () {
			this.$emit('fetch-data', {
				callback: () => {
					this.$store.dispatch('setModeView');
				},
			});
		},
		scrollToday: function () {
			this.$emit('scroll-today');
		},
		onScrollSpecifyDate: function(e) {
			this.$emit('specify-move-date', e);
		},
		logout: function() {
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
		undo: function() {
			const onFail = async (err) => {
				const callback = {
					401: () => {
						this.logout();
					},
				};
				Util.updateFail(this.$store, err.response, callback);
				
				let access_token = await DataSetManager.confirmAccessToken(this.$store);
				await this.dataset_manager.fetch(access_token)
					.then((data) => {
						this.$store.commit('createData', data);
					})
					.catch(async (e) => {
						let notification = null;
						switch(e.response.status) {
						case 400:
							notification = Notification.error('リクエストに失敗しました', 'notificationCreateData');
							break;
						case 401:
							notification = Notification.error('もう一度ログインしてください', 'notificationCreateData');
							this.logout();
							break;
						case 403:
							notification = Notification.error('権限がありません', 'notificationCreateData');
							this.logout();
							break;
						case 404:
							notification = Notification.error('契約者情報の取得に失敗しました', 'notificationCreateData');
							break;
						case 500:
							notification = Notification.error('情報の取得に失敗しました', 'notificationCreateData');
							break;
						case 504:
							notification = Notification.error('タイムアウトしました', 'notificationCreateData');
							break;
						default :
							notification = Notification.error('通信に失敗しました', 'notificationCreateData');
							break;
						}
						this.$store.commit('addNotification', notification);
					});
			};
			const onTokenFail = () => {
				this.logout();
			};
			this.dataset_manager.undo(null, onFail, onTokenFail);
		},
		redo: function() {
			const onFail = async (err) => {
				const callback = {
					401: () => {
						this.logout();
					},
				};
				Util.updateFail(this.$store, err.response, callback);
			};
			const onTokenFail = () => {
				this.logout();
			};
			this.dataset_manager.redo(null, onFail, onTokenFail);
		},
		onSelectBeginDate: function() {
			this.beginCalendar = false;
			
			if (this.begin_date !== undefined && this.begin_date !== null){
				this.$emit('specify-move-date', new Date(this.begin_date));
			}
		},
		onClickShowEditProjectPinned: function(e) {
			this.$emit('show-edit-project-pinned', e);
		}
	},
	computed: {
		headerColor: function() {
			if (this.isEditable)
				return 'deep-orange';
			return 'primary';
		},
		undoColor: function() {
			if (!this.$store.getters.canUndo)
				return 'deep-orange lighten-2';

			return 'white';
		},
		undoClass: function() {
			let classes = new Array();

			if (!this.$store.getters.canUndo)
				classes.push('disabled');

			return classes;
		},
		redoColor: function() {
			if (!this.$store.getters.canRedo)
				return 'deep-orange lighten-2';

			return 'white';
		},
		redoClass: function() {
			let classes = new Array();

			if (!this.$store.getters.canRedo)
				classes.push('disabled');

			return classes;
		},
		isBoardLeftPosition: function() {
			return this.$store.getters.boardLeftPosition !== 0;
		},
		canEdit: function() {
			return (!this.$store.getters.isDisplayListTypeMember) && this.$store.getters.isAdmin;
		},
	},
	watch: {
		toggleTick: function(val) {
			this.$emit('change-calendar-tick', {value: val});
		},
	},
}
</script>
<style scoped>
	.disabled {
		pointer-events: none;
	}

	.btn-toggle-board-left-position {
		min-width: 24px;
	}
	
	.btn-toggle-extension {
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		-webkit-transform: translateX(-50%);
		margin: auto;
		height: 15px;
		z-index: 104;
	}
	
	.btn-move-date {
		width: 120px;
	}
	
	.v-toolbar >>> .v-toolbar__extension {
		padding: 0px;
		border-top: dotted 1px #DFDFDF;
	}
</style>

